import * as runtime from '@/api/runtime'
import {
  BatchTrcContentDataRegisterRequest,
  BatchTrcContentDataRegisterRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcContentDataRegisterCondition,
  BatchTrcContentDataRegisterConditionFromJSON
} from '@/api/models/batch/BatchTrcContentDataRegisterCondition'

/**
 * 帳票作成
 */
export class BatchTrcContentDataRegisterApi extends runtime.BaseAPI {
  async register(request: BatchTrcContentDataRegisterRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/trc-content-data-register`,
      BatchTrcContentDataRegisterRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcContentDataRegisterCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcContentDataRegisterConditionFromJSON(jsonValue)
    ).value()
  }
}
